const loginDictEN = {
  to: "to",
  signInWith: "Sign in with your activated account's credentials",
  forgotPassword: "Forgot your password?",
  sendEmail: "Send Email",
  // toast
  pleaseFillOut: "Please fill out the username and password fields.",
  pleaseReverify: "Please reverify ReCaptcha.",
  incorrectCredentials: "Incorrect credentials.",
  tooManyLoginAttempts: "Too many failed login attempts. Please try again in a few minutes or use \"Forgot your password?\".",
  pleaseCheckEmail: "Please check your email address to activate your account.",
  pleaseCheckEmailTemp:
    "Please check the link sent to your email to change your password. It will be valid for 60 minutes.",
  userNotFound: "User not found.",
  thisEmailDoesnt: "This email doesn't correspond to this user.",
  error: "Error",
  success: "Success",
  notRegisteredYetRegisterAs: "Not registered yet? Register as",
  welcomeBack: "Welcome",
  emailOrUsername: "Email or username",
  enterRegisteredEmail: "Enter your registered email",
  enterYourPassword: "Enter your access password",
  rememberMe: "Remember me",
  accessMyAccount: "Access my account",
  notPartOfNetwork: "Not part of the network yet?",
  createAccountNow: "Create your account and start generating value today.",
  loginAndKeepGrowing: "Login and keep growing with Extraconomy",
  accessYourAccountDescription:
    "Access your account and take advantage of opportunities to expand your network, your earnings and your impact.",
  // Reset Password
  resetPassword: "Reset Password",
  enterNewPassword: "Enter your new password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  confirmNewPassword: "Confirm your new password",
  changePassword: "Change Password",
  backToLogin: "Back to login",
  invalidLink: "Invalid or expired link. Redirecting to login...",
  passwordsDoNotMatch: "Passwords do not match.",
  passwordTooShort: "Password must be at least 8 characters long.",
  passwordChangedSuccessfully: "Password changed successfully! Redirecting to login...",
  errorChangingPassword: "Error changing password. Please try again or request a new link.",
  resetYourPassword: "Reset your password",
  createNewPasswordDescription: "Create a new password to regain access to your account.",
  passwordAlreadyChanged: "This password change request has already been used.",
  enterTheEmailAddressAssociatedYourAccount: "Enter the email address associated with your account",
  weWillSendYouALinkToSecurelyCreateANewPassword:
    "We’ll send you a link to securely create a new password",
  active: "Active",
  memberCount: "Member Count",
  subnets: "Subnets",
  subnet: "Subnet",
  loginSEODescription:
    "Log in to Extraconomy to access your account, expand your network, and take advantage of exclusive business opportunities.",
  // Entrada vinda da Federnet (FedernetHandoff.js)
  federnetHandoffLoading: "Taking you to Extraconomy…",
  federnetHandoffErrorTitle: "Sign-in failed",
  federnetHandoffErrorText:
    "The link from Federnet has expired or was already used. Sign in with your username and password.",
  federnetHandoffGoToLogin: "Go to sign in",
};

export default loginDictEN;
